import React from "react";

const ThumbsUp = ({ color = "var(--icon-button-fill)", opacity = "var(--icon-button-opacity)" }) => (
  <svg
    width="41"
    height="39"
    viewBox="0 0 41 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    opacity={opacity}
  >
    <rect
      width="10.4936"
      height="20.9872"
      rx="2.09872"
      transform="matrix(-0.999504 0.0315017 0.0315017 0.999504 11.4849 14.3137)"
      fill={color}
    />
    <path
      d="M26.2251 14.9287C25.881 15.2903 25.3661 14.7454 26.0595 9.67324C26.9262 3.33306 24.729 1.29802 21.5326 1.39876C18.3363 1.4995 19.6005 7.77252 17.569 10.993C16.9315 12.0035 13.0955 15.6933 11.375 17.5011C8.61563 20.1872 4.63158 26.8789 10.7704 32.156C16.9092 37.4332 24.0766 36.9971 26.893 36.1195M26.2251 14.9287C30.433 13.0843 35.7826 12.9755 36.6379 15.0101C37.4933 17.0447 36.3128 18.1517 34.8814 18.8645M26.2251 14.9287C17.617 18.7019 20.4248 22.0494 23.2173 21.9614M34.8814 18.8645C33.45 19.5773 34.1417 19.721 29.0329 21.1531C27.8998 21.4707 24.5439 21.9196 23.2173 21.9614M34.8814 18.8645C37.8724 18.7702 40.6299 21.9362 37.1914 24.485M23.2173 21.9614C22.7245 22.5854 22.4149 22.5299 22.2149 23.0479C22.0015 23.6011 21.9436 24.0947 22.0171 24.5307M25.5373 26.9434C28.6111 27.4655 33.0393 26.7933 36.1455 25.1375C36.5467 24.9236 36.8937 24.7057 37.1914 24.485M25.5373 26.9434C25.1109 28.2483 25.0491 30.3909 26.7522 31.6523M25.5373 26.9434C23.6247 26.6185 22.2364 25.8311 22.0171 24.5307M37.1914 24.485C40.0529 27.4077 39.7542 29.883 37.1521 31.3245M26.7522 31.6523C27.6396 32.3095 29.0062 32.7275 31.0501 32.6631C33.6667 32.5806 35.7458 32.1036 37.1521 31.3245M26.7522 31.6523C25.4637 32.6001 24.066 34.606 26.893 36.1195M37.1521 31.3245C39.158 35.3758 35.968 38.821 29.0517 36.9347C28.1514 36.6891 27.4424 36.4136 26.893 36.1195M22.0171 24.5307C21.2682 25.1934 19.2704 26.2376 17.2703 25.1129"
      stroke={color}
      strokeWidth="2.06055"
      strokeLinecap="round"
    />
  </svg>
);

export default ThumbsUp;
